import * as React from 'react';
import moment, { Moment } from 'moment';
import { Tooltip } from 'antd';
import { bulkHolidayCheck } from '../network/pickup.api';
import AuthHelper from '../auth/auth-helper';

export interface IHolidayDate {
    date: string;
    holidayType: string;
    holidayName: string;
}

interface FetchHolidayOptions {
    check_pickup?: boolean;
    check_delivery?: boolean;
    consignment?: {
        origin_details?: {
            pincode?: string;
            city?: string;
            state?: string;
        };
        [key: string]: any;
    };
}

export const fetchHolidayDatesForRange = async (
    startDate: Moment,
    endDate: Moment,
    options: FetchHolidayOptions = {},
): Promise<Map<string, IHolidayDate>> => {
    const organisationId = AuthHelper.getOrganisationId();
    if (!organisationId) {
        return new Map();
    }

    const dateList: string[] = [];
    const current = startDate.clone().startOf('day');
    const end = endDate.clone().startOf('day');
    while (current.isSameOrBefore(end)) {
        dateList.push(current.format('YYYY-MM-DD'));
        current.add(1, 'day');
    }

    const body: any = {
        dates: dateList,
        check_pickup: options.check_pickup !== undefined ? options.check_pickup : true,
        check_delivery: options.check_delivery !== undefined ? options.check_delivery : false,
        consignment: options.consignment || {},
    };

    const response = await bulkHolidayCheck(body);
    const holidayMap = new Map<string, IHolidayDate>();

    if (response.isSuccess && Array.isArray(response.data)) {
        response.data.forEach((item: any) => {
            if (item.is_holiday) {
                holidayMap.set(item.date, {
                    date: item.date,
                    holidayType: item.holiday_type || '',
                    holidayName: item.holiday_name || '',
                });
            }
        });
    }

    return holidayMap;
};

export const createDisabledDateFunction = (
    holidayMap: Map<string, IHolidayDate>,
    disablePastDates: boolean = true,
) => (current: Moment): boolean => {
    if (!current) return false;
    const dateStr = current.format('YYYY-MM-DD');
    if (disablePastDates && dateStr < moment().format('YYYY-MM-DD')) {
        return true;
    }
    return holidayMap.has(dateStr);
};

export const createDateCellRender = (
    holidayMap: Map<string, IHolidayDate>,
) => (current: Moment): React.ReactNode => {
    const dateStr = current.format('YYYY-MM-DD');
    const holiday = holidayMap.get(dateStr);

    if (!holiday) {
        return <div>{current.date()}</div>;
    }

    return (
        <Tooltip title={`${holiday.holidayName} (${holiday.holidayType})`}>
            <div
                style={{
                    position: 'relative',
                    width: '100%',
                    height: '100%',
                    pointerEvents: 'all',
                }}
            >
                <span style={{ color: 'red', fontWeight: 600 }}>
                    {current.date()}
                </span>
                <div
                    style={{
                        position: 'absolute',
                        bottom: 2,
                        left: '50%',
                        transform: 'translateX(-50%)',
                        width: 4,
                        height: 4,
                        borderRadius: '50%',
                        backgroundColor: 'red',
                    }}
                />
            </div>
        </Tooltip>
    );
};
